import { Button } from "@/components/ui/button";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
// import { IoSearch } from "react-icons/io5";
import { useCallback, useEffect, useState } from "react";
import noEmailIcon from "@/assets/myaccount/no-email.svg";

import { useLoading } from "@/contexts/LoadingContext";
// import useDebounce from "@/hooks/useDebounce";
// import unwatchIcon from "@/assets/myaccount/remove-watchlist.svg";

import { DeleteEmailTemplate, fetchEmailemplate, getEmailTemplateValues } from "../services/emailTemplateServices";
import { TbPencil } from "react-icons/tb";
import { RiDeleteBin5Line } from "react-icons/ri";
import EmailTemplateDialog from "@/components/dialogs/dialog-email-template";
import ConfirmDeleteDialog from "@/components/dialogs/dialog-confirm-delete";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import useDebounce from "@/hooks/useDebounce";
import { IoSearch } from "react-icons/io5";
import { Input } from "@/components/ui/input";
import noResultsFound from "@/assets/projectlisiting/no-results.svg";
import toastService from "@/services/toastService";

interface PaginationData {
  page: number;
  limit: number;
  nextPage: number;
}

interface EmailTemplate {
  id: number;
  template_fs: string | false;
  lang: string | false;
  render_model: string;
  name: string;
  description: string | false;
  active: boolean;
  template_category: string;
  model_id: [number, string];
  model: string;
  subject: string;
  email_from: string | false;
  user_id: number | false;
  use_default_to: boolean;
  email_to: string | false;
  partner_to: string | false;
  email_cc: string | false;
  reply_to: string | false;
  body_html: string;
  attachment_ids: number[];
  report_template_ids: number[];
  email_layout_xmlid: string | false;
  mail_server_id: number | false;
  scheduled_date: string | false;
  auto_delete: boolean;
  ref_ir_act_window: boolean;
  can_write: boolean;
  is_template_editor: boolean;
  display_name: string;
  create_uid: [number, string];
  create_date: string;
  write_uid: [number, string];
  write_date: string;
  company_id: [number, string];
}

const EmailTemplate = () => {
  const [pagination, setPagination] = useState<PaginationData>({
    page: 1,
    limit: 10,
    nextPage: -1,
  });
  const [EmailTemplates, setEmailTemplates] = useState<EmailTemplate[]>([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState<"add" | "edit">("add");
  const [selectedTemplate, setSelectedTemplate] =
    useState<EmailTemplate | null>(null);
  const [templateToDeleteId, setTemplateToDeleteId] = useState<number | null>(
    null
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [emailTemplateValues, setEmailTemplateValues] = useState<any>()

  // const [searchTerm, setSearchTerm] = useState("");
  const { setLoading } = useLoading();
  const debouncedSearchTerm = useDebounce(searchTerm);

  const fetchEmailTemplateList = useCallback(
    async (query?: string, page: number = pagination.page) => {
      try {
        setLoading(true);
        const params = {
          page: page,
          limit: pagination.limit,
          q: query,

          // ...(isSubscribedRoute && { subscribed: true }),
        };
        const response = await fetchEmailemplate(params);
        setEmailTemplates(response?.data?.templates || []);
        setPagination((prev) => ({
          ...prev,
          page: page,
          nextPage: response?.data?.nextPage ?? -1,
        }));
      } catch (error) {
        console.error("Error fetching watchlist data:", error);
        setEmailTemplates([]);
      } finally {
        setLoading(false);
      }
    },
    [pagination.limit, setLoading]
  );

    const fetchEmailTemplateValues = useCallback(
    async () => {
      try {
        setLoading(true);
        const response = await getEmailTemplateValues();
        console.log(response,"line 115")
        setEmailTemplateValues(response?.data || []);
        // setPagination((prev) => ({
        //   ...prev,
        //   page,
        //   nextPage: response?.data?.nextPage ?? -1,
        // }));
      } catch (error) {
        console.error("Error fetching watchlist data:", error);
        setEmailTemplateValues([]);
      } finally {
        setLoading(false);
      }
    },
    []
  );
  console.log("line 146",openDialog)

  

  useEffect(() => {
    fetchEmailTemplateList(debouncedSearchTerm, 1); 
     fetchEmailTemplateValues()
  }, [fetchEmailTemplateList]);

  const Refresh = () => {
    fetchEmailTemplateList();
  };

  const handleDelete = async () => {
    console.log("");
    if (!templateToDeleteId) return;
    try {
      setLoading(true);
      await DeleteEmailTemplate(templateToDeleteId);
      toastService.success("Template deleted successfully");
      setIsConfirmDeleteOpen(false);
      setTemplateToDeleteId(null);
      Refresh();
    } catch (error) {
      console.error("Failed to delete template:", error);
    } finally {
      setLoading(false);
    }
  };

  // function stripHtmlAndQwebTags(html: string): string {
  //   return (
  //     html
  //       // Remove QWeb templating tags like <t t-if="...">, <t t-out="..."> etc.
  //       .replace(/<t[^>]*>/g, "")
  //       .replace(/<\/t>/g, "")
  //       // Remove all HTML tags
  //       .replace(/<[^>]+>/g, "")
  //       // Replace multiple spaces/newlines with single space
  //       .replace(/\s+/g, " ")
  //       .trim()
  //   );
  // }

  useEffect(() => {
    fetchEmailTemplateList(debouncedSearchTerm, 1);
  }, [fetchEmailTemplateList, debouncedSearchTerm]);

  const handlePageChange = (newPage: number) => {
    if (
      newPage >= 1 &&
      (newPage < pagination.page || pagination.nextPage !== -1)
    ) {
      fetchEmailTemplateList(debouncedSearchTerm, newPage);
    }
  };

  return (
    <div className="">
   
      {EmailTemplates.length === 0 ? (
  debouncedSearchTerm ? (
    <>
                   <div className="mx-8 border-b  my-[2%] border-gray-300 pb-4 mb-4">
        <div className="flex justify-between   items-center ">
            
          
              <fieldset className="relative w-[20vw] h-[40px]">
                <Button
                  variant="ghost"
                  size="sm"
                  className="absolute left-1 top-1/2 transform -translate-y-1/2 hover:bg-transparent hover:text-inherit focus:bg-transparent focus:text-inherit"
                >
                  <IoSearch size={15} />
                </Button>

                <Input
                  type="text"
                  placeholder="Search ..."
                  className="w-full pl-10 pr-4 py-1 h-[40px] border rounded"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </fieldset>
              <Button
                size="sm"
                variant="outline"
                className="bg-[#181818] h-[40px] text-white px-8 hover:bg-[#181818]/80 hover:text-white "
                onClick={() => {
                  console.log("click the add new 1")
                  setDialogMode("add");
                  setOpenDialog(true);
                }}
              >
                Add New
              </Button>
           
          </div>

    </div>

    
           <div className="w-full flex justify-center items-center mt-20">
      <div className="flex flex-col items-center text-center">
        <img
          src={noResultsFound}
          alt="No results found"
          className="w-40 h-40 2xl:w-80 2xl:h-80"
        />
        <p className="text-[#181818] text-lg font-medium">No Templates Found</p>
        <p className="text-gray-500 text-sm mt-2">
          It looks like there are no templates matching your search criteria.
        </p>
      </div>
    </div>
    </>
 
   
 
  ) : (
 
    <div className="w-full min-h-[80vh]  flex justify-center items-center">
      <div className="flex flex-col text-center items-center">
        <img src={noEmailIcon} alt="No templates" className="w-4/5" />
        <h2 className="text-[24px] text-[#202b49] mt-4">
          You have no email templates
        </h2>
        <Button
          size="sm"
          variant="outline"
          className="bg-[#181818] text-white px-4 mt-4"
          onClick={() => {
            console.log("click the add new 2")
            setDialogMode("add");
            setOpenDialog(true);
          }}
        >
          Add New
        </Button>
      </div>
    </div>
  )
) : (
    <>
                     <div className="mx-8 border-b  my-[2%] border-gray-300 pb-4 mb-4">
        <div className="flex justify-between   items-center ">
            
          
              <fieldset className="relative w-[20vw] h-[40px]">
                <Button
                  variant="ghost"
                  size="sm"
                  className="absolute left-1 top-1/2 transform -translate-y-1/2 hover:bg-transparent hover:text-inherit focus:bg-transparent focus:text-inherit"
                >
                  <IoSearch size={15} />
                </Button>

                <Input
                  type="text"
                  placeholder="Search ..."
                  className="w-full pl-10 pr-4 py-1 h-[40px] border rounded"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </fieldset>
              <Button
                size="sm"
                variant="outline"
                className="bg-[#181818] h-[40px] text-white px-8 hover:bg-[#181818]/80 hover:text-white "
                onClick={() => {
                  console.log("click the add new 1")
                  setDialogMode("add");
                  setOpenDialog(true);
                }}
              >
                Add New
              </Button>
           
          </div>

    </div>
    
          <div className="mx-8 rounded-lg overflow-hidden border mt-4 mb-6 border-gray-300">
            <Table>
              <TableHeader className="bg-[#f9fafb]">
                <TableRow>
                  <TableHead className="p-2 px-4 text-[16px] leading-[24px] text-left text-[#181818]">
                    Template Name 
                  </TableHead>
                  <TableHead className="p-2 text-left text-[16px] leading-[24px] text-[#181818]">
                    Subject
                  </TableHead>
                  <TableHead className="p-2 text-left text-[16px] leading-[24px] text-[#181818]">
                    Create Date
                  </TableHead>
                  <TableHead className="p-2 text-left text-[16px] leading-[24px] text-[#181818]">
                    Actions
                  </TableHead>
                </TableRow>
              </TableHeader>

             <TableBody>
  {EmailTemplates.map((entry, index) => (
    <TableRow key={index}>
      <TableCell className="p-3 px-4 text-left">
        {entry.name.split(" ").slice(0, 10).join(" ")}
        {entry.name.split(" ").length > 10 && "..."}
      </TableCell>
      <TableCell className="p-2 text-left">
        {entry.subject.split(" ").slice(0, 10).join(" ")}
        {entry.subject.split(" ").length > 10 && "..."}
      </TableCell>
      <TableCell className="p-2 text-left">
        {entry.create_date?.split(" ")[0] ?? "—"}
      </TableCell>
      <TableCell className="p-1">
        <div className="flex justify-start items-start space-x-2">
          <Button
            variant="secondary"
            size="icon"
            className="w-[32px] h-[32px] flex items-center justify-center"
            onClick={() => {
              setDialogMode("edit");
              setSelectedTemplate(entry);
              setOpenDialog(true);
            }}
          >
            <TbPencil size={18} className="cursor-pointer" />
          </Button>
          <Button
            variant="secondary"
            size="icon"
            className="w-[32px] h-[32px] flex items-center justify-center disabled:opacity-50"
            onClick={() => {
              setTemplateToDeleteId(entry.id);
              setIsConfirmDeleteOpen(true);
            }}
          >
            <RiDeleteBin5Line size={18} className="cursor-pointer" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  ))}
</TableBody>

              <TableRow className="rounded-b-lg bg-slate-100">
                <TableCell colSpan={5}>
                  <div className="flex justify-center items-center">
                    <div className="flex items-center space-x-4">
                      <Button
                        variant="outline"
                        disabled={pagination.page === 1}
                        onClick={() => handlePageChange(pagination.page - 1)}
                      >
                        <FaChevronLeft />
                      </Button>
                      <span className="text-gray-700 font-medium">
                        Page {pagination.page}
                      </span>
                      <Button
                        variant="outline"
                        disabled={pagination.nextPage === -1}
                        onClick={() => handlePageChange(pagination.page + 1)}
                      >
                        <FaChevronRight />
                      </Button>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </Table>
        
            {isConfirmDeleteOpen && (
              <ConfirmDeleteDialog
                open={isConfirmDeleteOpen}
                onOpenChange={(val) => {
                  if (!val) setTemplateToDeleteId(null);
                  setIsConfirmDeleteOpen(val);
                }}
                handleDelete={handleDelete}
                type="event"
              />
            )}
          </div>
        </>
)} 
    <EmailTemplateDialog
              open={openDialog}
              Refresh={Refresh}
              onOpenChange={setOpenDialog}
              type={dialogMode}
              initialValues={
                dialogMode === "edit" && selectedTemplate
                  ? {
                      id: selectedTemplate.id,
                      name: selectedTemplate.name,
                      subject: selectedTemplate.subject,
                      body_html: selectedTemplate.body_html,
                    }
                  : undefined
              }
              emailTemplateValues ={emailTemplateValues}
            />
    </div>
  );
};

export default EmailTemplate;
